import { TLandmarkShort } from '@/screens/LandmarkMainPage/domain/Landmarks.domain';
import * as S from './LandmarksCarousel.styles';
import { useRef } from 'react';
import { useCarousel } from '@/common/app/hooks/useCarousel';
import Link from 'next/link';
import URL from '@/common/app/utils/urlsUtils';

type LandmarksCarouselProps = {
    landmarks: TLandmarkShort[];
    stateCode: string;
    destinationSlug: string;
};

export const LandmarksCarousel = ({
    landmarks,
    stateCode,
    destinationSlug,
}: LandmarksCarouselProps) => {
    const scrollRef = useRef<HTMLDivElement>(null);

    const {
        prevBtnIsActive,
        nextBtnIsActive,
        onClickHandler,
        onScrollHandler,
        DIRECTION,
        withDot,
    } = useCarousel({
        ref: scrollRef,
        countItems: landmarks.length,
    });

    return (
        <div className="container">
            <S.Title>Locations Youʹll Explore</S.Title>
            <S.CarouselWraper>
                <S.Gallery ref={scrollRef} onScroll={onScrollHandler}>
                    <S.InnerContainer className="carousel-container">
                        {landmarks.map((landmark, index) => (
                            <Link
                                key={index}
                                href={`/destination/${stateCode}/${destinationSlug}/landmarks/${landmark.slug}/`.toLowerCase()}
                                passHref
                                prefetch={false}
                            >
                                <S.CardWidth className="card" target="__blank" rel="nofollow">
                                    <S.CardContainer numberOfItems={landmarks.length}>
                                        <S.Image
                                            src={`${URL.image}/landmark/${landmark.id}/700x600/${landmark.slug}.jpg`}
                                            alt={landmark.name}
                                            width="75"
                                            height="75"
                                            loading="lazy"
                                            decoding="async"
                                        />
                                        <S.CardContent>
                                            <S.LandmarkTitle>{landmark.name}</S.LandmarkTitle>
                                            <S.ReadMore>
                                                Read more <S.Arrow />
                                            </S.ReadMore>
                                        </S.CardContent>
                                    </S.CardContainer>
                                </S.CardWidth>
                            </Link>
                        ))}
                    </S.InnerContainer>
                </S.Gallery>
                {prevBtnIsActive && withDot && (
                    <S.CenterLeftArrow
                        onClick={() => onClickHandler(DIRECTION.prev)}
                        disabled={false}
                    />
                )}
                {nextBtnIsActive && withDot && (
                    <S.CenterRightArrow
                        onClick={() => onClickHandler(DIRECTION.next)}
                        disabled={false}
                    />
                )}
            </S.CarouselWraper>
        </div>
    );
};
